export const MAX_CALENDARS_FOR_TOP_CALENDARS_LIST = 5;
export const DRAG_X_OFFSET = -10;
export const DRAG_Y_OFFSET = 5;
